import { motion } from "framer-motion";
import EducationTile from "./educationTile";
import PageTitle from "../common/pageTitle";
import WorkExperience from "./workExperience";

function Resume() {
  const languages = [
    { name: "C", color: "#00599C" },
    { name: "CSS3", color: "#1572B6" },
    { name: "Dart", color: "#0175C2" },
    { name: "HTML5", color: "#E34F26" },
    { name: "Java", color: "#ED8B00" },
    { name: "JavaScript", color: "#F7DF1E" },
    { name: "Python", color: "#3670A0" },
    { name: "TypeScript", color: "#007ACC" },
  ];

  const frameworksAndLibraries = [
    { name: "GraphQL", color: "#E10098" },
    { name: "Apollo-GraphQL", color: "#3982CE" },
    { name: "Bootstrap", color: "#8511FA" },
    { name: "Chakra", color: "#4ED1C5" },
    { name: "Chart.js", color: "#F5788D" },
    { name: "Context-API", color: "#ffffff" },
    { name: "DaisyUI", color: "#5A0EF8" },
    { name: "Express.js", color: "#ffffff" },
    { name: "Flutter", color: "#02569B" },
    { name: "JWT", color: "#ffffff" },
    { name: "MUI", color: "#0081CB" },
    { name: "Next JS", color: "#ffffff" },
    { name: "NodeJS", color: "#6DA55F" },
    { name: "Nodemon", color: "#BBDEAD" },
    { name: "PNPM", color: "#ffffff" },
    { name: "React", color: "#61DAFB" },
    { name: "React Native", color: "#61DAFB" },
    { name: "tRPC", color: "#2596BE" },
    { name: "Zod", color: "#3068b7" },
    { name: "NumPy", color: "#013243" },
    { name: "Pandas", color: "#150458" },
    { name: "Prisma", color: "#3982CE" },
  ];

  const databases = [
    { name: "MongoDB", color: "#4ea94b" },
    { name: "MySQL", color: "#4479A1" },
    { name: "Postgres", color: "#316192" },
  ];

  const cloud = [
    { name: "AWS", color: "#FF9900" },
    { name: "Firebase", color: "#039BE5" },
  ];

  const tools = [
    { name: "Adobe Photoshop", color: "#31A8FF" },
    { name: "Adobe Premiere Pro", color: "#9999FF" },
    { name: "Canva", color: "#00C4CC" },
    { name: "Figma", color: "#F24E1E" },
    { name: "GitLab CI", color: "#ffffff" },
    { name: "Windows Terminal", color: "#ffffff" },
    { name: "NPM", color: "#CB3837" },
    { name: "Postman", color: "#FF6C37" },
  ];

  const versionControl = [
    { name: "Git", color: "#F05033" },
    { name: "GitHub", color: "#ffffff" },
    { name: "GitLab", color: "#ffffff" },
    { name: "Bitbucket", color: "#0047B3" },
  ];

  return (
    <div className="px-5 mt-5">
      <PageTitle title={"Resume"} />
      <EducationTile />
      <div className="mt-5 text-white text-3xl font-poppins font-extrabold relative pb-2">
        Work Experience
      </div>
      <div className="absolute w-10 h-2 rounded-lg bg-purple-500"></div>
      <WorkExperience />
      <br />
      <PageTitle title={"Skills"} />
      <div className="mt-10 text-white text-2xl font-poppins font-extrabold relative pb-1.5">
        Languages
      </div>
      <div className="flex flex-wrap gap-2 mt-3">
        {languages.map((language, index) => {
          const delay = index * 0.1;
          return (
            <motion.div
              exit={{ scale: 1 }}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.3, delay }}
            >
              <div
                key={index}
                className="pill px-3 font-semibold"
                style={{ color: language.color }}
              >
                {language.name}
              </div>
            </motion.div>
          );
        })}
      </div>
      <div className="mt-7 text-white text-2xl font-poppins font-extrabold relative pb-1.5">
        Frameworks & Libraries
      </div>
      <div className="flex flex-wrap gap-2 mt-3">
        {frameworksAndLibraries.map((framework, index) => {
          const delay = index * 0.1;
          return (
            <motion.div
              exit={{ scale: 1 }}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.3, delay }}
            >
              <div
                key={index}
                className="pill px-3 font-semibold"
                style={{ color: framework.color }}
              >
                {framework.name}
              </div>
            </motion.div>
          );
        })}
      </div>
      <div className="mt-7 text-white text-2xl font-poppins font-extrabold relative pb-1.5">
        Cloud Technologies
      </div>
      <div className="flex flex-wrap gap-2 mt-3">
        {cloud.map((cloud, index) => {
          const delay = index * 0.1;
          return (
            <motion.div
              exit={{ scale: 1 }}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.3, delay }}
            >
              <div
                key={index}
                className="pill px-3 font-semibold"
                style={{ color: cloud.color }}
              >
                {cloud.name}
              </div>
            </motion.div>
          );
        })}
      </div>
      <div className="mt-7 text-white text-2xl font-poppins font-extrabold relative pb-1.5">
        Databases
      </div>
      <div className="flex flex-wrap gap-2 mt-3">
        {databases.map((database, index) => {
          const delay = index * 0.1;
          return (
            <motion.div
              exit={{ scale: 1 }}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.3, delay }}
            >
              <div
                key={index}
                className="pill px-3 font-semibold"
                style={{ color: database.color }}
              >
                {database.name}
              </div>
            </motion.div>
          );
        })}
      </div>
      <div className="mt-7 text-white text-2xl font-poppins font-extrabold relative pb-1.5">
        Tools
      </div>
      <div className="flex flex-wrap gap-2 mt-3">
        {tools.map((tool, index) => {
          const delay = index * 0.1;
          return (
            <motion.div
              exit={{ scale: 1 }}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.3, delay }}
            >
              <div
                key={index}
                className="pill px-3 font-semibold"
                style={{ color: tool.color }}
              >
                {tool.name}
              </div>
            </motion.div>
          );
        })}
      </div>
      <div className="mt-7 text-white text-2xl font-poppins font-extrabold relative pb-1.5">
        Version Control
      </div>
      <div className="flex flex-wrap gap-2 my-3">
        {versionControl.map((versionControl, index) => {
          const delay = index * 0.1;
          return (
            <motion.div
              exit={{ scale: 1 }}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.3, delay }}
            >
              <div
                key={index}
                className="pill px-3 font-semibold"
                style={{ color: versionControl.color }}
              >
                {versionControl.name}
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}

export default Resume;
